import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_PUBLICATIONS: "SET_PUBLICATIONS",
    GENERAL_PUBLICATIONS_REQUEST: "GENERAL_PUBLICATIONS_REQUEST",
    GENERAL_PUBLICATIONS_SUCCESS: "GENERAL_PUBLICATIONS_SUCCESS",
    GENERAL_PUBLICATIONS_ERROR: "GENERAL_PUBLICATIONS_ERROR",
    DELETE_PUBLICATIONS_SUCCESS: "DELETE_PUBLICATIONS_SUCCESS",
};

export const setPublications = (profile) => {
    const publicationsWithPersonId = profile.publications.map( publication => Object.assign( publication, { person_id: profile.id } ) );
    const noData = publicationsWithPersonId.length === 0;
    return {
        type: actions.SET_PUBLICATIONS,
        personId: profile.id,
        body: publicationsWithPersonId,
        noData,
    }
};

export const publicationsApiCall = (personId, payload, type, callbackToHOC) => {
    const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : "DELETE" );
    const endpoint = type === 'CREATE' ?  '' : ( payload.id ? `/${ payload.id }` : `/${ payload }`);

    const _payload = {...payload};

    if (requestType !== 'DELETE') {
        _payload.publication_date = `${ payload.year.value }-0${ payload.month.value }`;
    }

    return (dispatch) => {
        dispatch({
            type: actions.GENERAL_PUBLICATIONS_REQUEST,
            isPublicationsFetching: true,
            isPublicationsError: false,
        });

        requestHelpers
            .authenticatedPostRequest(`/profiles/${personId}/publication${endpoint}`, _payload, requestType)
            .then((response) => {
                callbackToHOC();
                payload.hasOwnProperty('id') ? _payload.id = _payload.id || response.data.id : payload;
                return dispatch({
                    type: requestType === 'DELETE' ? actions.DELETE_PUBLICATIONS_SUCCESS : actions.GENERAL_PUBLICATIONS_SUCCESS,
                    personId,
                    body: requestType === 'DELETE' ? payload : _payload,
                    isPublicationsFetching: false,
                    isPublicationsError: false,
                })
            })
            .catch((error) => {
                callbackToHOC(error);
                return dispatch({
                    type: actions.GENERAL_PUBLICATIONS_ERROR,
                    isPublicationsFetching:  false,
                    isPublicationsError: true,
                    error: error.status,
                })
            })
      dispatch(updateTodoList(personId, 8));
    }
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/publications.js